/* ==========================================================================
   MEE BARSA — PHONE HEADER UTILITIES  (2026-08-07)

   Collapses the homepage header's four controls behind one mark on phones so
   the signature can lead and both sides of the grid can be 44px.
   Layout and reasoning: component-mb-header.css §6.

   SECOND PASS — A DRAWER, NOT A DROPDOWN. The first build dropped the icons
   onto a small purple panel under the bar. Adarsh: "This doesnt look good I
   guess a vertical menu coming from right, identical to the menu click of the
   right." Correct, and worth recording why: the page already has a vocabulary
   for "more things live here" — the MENU drawer. Full height, slides, words in
   Cormorant rather than icons, dims the page behind it. A floating icon slab
   was a second unrelated idiom doing the same job. This mirrors the left
   drawer and comes from the right.

   WHY THE MARKUP IS BUILT HERE, NOT IN sections/mb-opening.liquid: the control
   is useless without JS, so rendering it in Liquid would leave a dead button
   for no-JS visitors. Same arrangement the search field already has.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__mbHeaderUtilsBound) return;
  window.__mbHeaderUtilsBound = true;

  function link(href, label) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = label;
    return a;
  }

  function build(chrome) {
    if (!chrome || chrome.__mbUtilsBound) return;
    var links = chrome.querySelector('.mb-open-links');
    if (!links) return;
    chrome.__mbUtilsBound = true;

    var get = function (sel) { return links.querySelector(sel); };
    var accountEl = get('a[aria-label*="account" i]');
    var wishEl = get('a[aria-label="Wishlist"]');
    var bagEl = get('a[aria-label="Bag"]');
    var searchEl = get('.mb-search');

    /* the drawer — same classes as the MENU drawer so it inherits every bit of
       its styling; only the side modifier differs */
    var drawer = document.createElement('nav');
    drawer.className = 'mb-open-drawer mb-open-drawer--right';
    drawer.id = 'mbUtilsDrawer-' + Math.random().toString(36).slice(2, 7);
    drawer.setAttribute('aria-label', 'Search and account');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('inert', '');
    drawer.tabIndex = -1;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'mb-open-close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';
    drawer.appendChild(close);

    var nav = document.createElement('div');
    nav.className = 'mb-dw-nav';
    /* a real search field, not an icon: clone the component and switch it to
       its always-open drawer variant, exactly as the MENU drawer does */
    if (searchEl) {
      var s = searchEl.cloneNode(true);
      s.classList.add('mb-search--drawer');
      var wrap = document.createElement('div');
      wrap.className = 'mb-open-drawer-search';
      wrap.appendChild(s);
      nav.appendChild(wrap);
    }
    if (accountEl) nav.appendChild(link(accountEl.getAttribute('href'), 'Account'));
    if (wishEl) nav.appendChild(link(wishEl.getAttribute('href'), 'Wishlist'));
    if (bagEl) nav.appendChild(link(bagEl.getAttribute('href'), 'Bag'));
    drawer.appendChild(nav);
    document.body.appendChild(drawer);

    /* its own scrim rather than the hero's, so the two drawers can never fight
       over the same element's class */
    var scrim = document.createElement('div');
    scrim.className = 'mb-open-scrim mb-utils-scrim';
    document.body.appendChild(scrim);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mb-open-utils';
    btn.setAttribute('aria-label', 'Search, account, wishlist and bag');
    btn.setAttribute('aria-controls', drawer.id);
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="mb-open-utils-mark" aria-hidden="true"></span>';
    /* last child, so it lands in the grid's third column once .mb-open-links
       is hidden by the phone stylesheet. display:none on desktop takes no track. */
    chrome.appendChild(btn);

    function isOpen() { return drawer.classList.contains('is-open'); }
    function setOpen(open) {
      if (open) drawer.removeAttribute('inert');
      drawer.style.setProperty('transition', 'none', 'important');
      drawer.style.setProperty('transform', open ? 'translateX(0)' : 'translateX(100%)', 'important');
      drawer.classList.toggle('is-open', open);
      scrim.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) drawer.focus();
      else drawer.setAttribute('inert', '');
    }

    btn.addEventListener('click', function (e) { e.stopPropagation(); setOpen(!isOpen()); });
    close.addEventListener('click', function () { setOpen(false); btn.focus(); });
    scrim.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { setOpen(false); btn.focus(); }
      if (e.key === 'Tab' && isOpen()) {
        var focusable = drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var active = document.activeElement;
        if (e.shiftKey && (active === first || !drawer.contains(active))) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && (active === last || !drawer.contains(active))) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    /* the dot: collapsing everything costs one tap to the bag, so say when
       there is something in it. /cart.js on idle stays correct after an AJAX
       add, where a Liquid-rendered count would go stale. */
    var idle = window.requestIdleCallback || function (f) { return window.setTimeout(f, 900); };
    idle(function () {
      if (!window.fetch) return;
      window.fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.item_count) return;
          var dot = document.createElement('span');
          dot.className = 'mb-open-utils-dot';
          dot.setAttribute('aria-hidden', 'true');
          btn.appendChild(dot);
          btn.setAttribute('aria-label',
            'Search, account, wishlist and bag — ' + cart.item_count + ' in bag');
        })
        .catch(function () {});
    });
  }

  function boot(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll('.mb-open-chrome'));
    if (scope.matches && scope.matches('.mb-open-chrome')) nodes.unshift(scope);
    for (var i = 0; i < nodes.length; i++) build(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
